import React, { useEffect, useState } from 'react'

export default function AdminNavbarButton({ btn, setDisplay, theme, display}) {
    const [btnSelected, setBtnSelected] = useState(false);
    useEffect(()=>{
        if(display===btn.displayNum){
            setBtnSelected(true);
        }
        else{
            setBtnSelected(false);
        }
    },[display])
    return (
        <div className={btnSelected ? "adminNavbarButton_selected" : 'adminNavbarButton'} style={{width:btnSelected ? "40%" : "30%", backgroundColor: !btnSelected ? theme.primary_color : theme.secondary_color ,color:!btnSelected ? theme.secondary_color : theme.primary_color, textShadow:`1px 1px 3px ${theme.accent_color}`}} onClick={()=>{setDisplay(btn.displayNum)}}>{btn.title}</div>
    )
}
